/**
 * @generated SignedSource<<e9a86803f0639bc2dab372633167789e>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}
export type useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
  };
export type useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
  };
export type useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    type: string;
    inlineResolveProperties: useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment_location =

    | useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment
    | useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment;
export type useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment =
  {
    __typename?: "Comment";
    id: string;
    parentId: string | null;
    location: useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment_location;
  };
export type useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList =
  {
    __typename?: "PaginatedCommentList";
    nodes: Array<useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList_nodes_Comment | null> | null;
  };
export type useFocusedCommentInlineCommentMarkerRefQuery_Query = {
  __typename?: "Query";
  comments: useFocusedCommentInlineCommentMarkerRefQuery_comments_PaginatedCommentList | null;
};
export type useFocusedCommentInlineCommentMarkerRefQueryVariables = Exact<{
  commentId: Scalars["ID"]["input"];
  pageId: Scalars["ID"]["input"];
  contentStatus?: InputMaybe<
    Array<InputMaybe<GraphQLContentStatus>> | InputMaybe<GraphQLContentStatus>
  >;
}>;
export type useFocusedCommentInlineCommentMarkerRefQuery =
  useFocusedCommentInlineCommentMarkerRefQuery_Query;
